'use client';

import { usePathname } from 'next/navigation';
import { ReactNode, useEffect } from 'react';

import { useProfile } from '@/shared/hooks';

const ArticleDetailCopyGuard = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  const pathname = usePathname();
  const { profile } = useProfile();

  useEffect(() => {
    const isStaff = profile?.isStaff;
    const addSourceEndOfCopy = (event: ClipboardEvent) => {
      event.preventDefault();
      if (!event.clipboardData) return;
      const newsUrl = `${process.env.NEXT_PUBLIC_APP_BASE_URL}${pathname}`;
      const selection = window.getSelection()?.toString() || '';
      const sourceText = `\n출처: ${newsUrl} [${title} | 요즘IT]`;
      const newText = selection + sourceText;

      event.clipboardData.setData('text/plain', newText);
    };

    const preventCopy = (event: ClipboardEvent) => {
      event.preventDefault();

      if (!event.clipboardData) return;

      event.clipboardData.setData('text/plain', '');
    };

    const handleCopy = (event: ClipboardEvent) => {
      if (isStaff) return;

      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (!isMobile) return preventCopy(event);

      return addSourceEndOfCopy(event);
    };

    document.addEventListener('copy', handleCopy);

    return () => {
      document.removeEventListener('copy', handleCopy);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile?.isStaff]);
  return <>{children}</>;
};

export default ArticleDetailCopyGuard;
